import request from './request';

type PaginationRequest = {
  page_number: number;
  page_size: number;
};

export type GetTradingProductsRequest = {
  productInfo?: {
    keyword?: string;
    city?: string;
    source?: string;
    item_number?: string;
  };
  pagination: PaginationRequest;
};

export type TradingProduct = {
  uuid: string;
  img_url: string;
  product_name?: string;
  product_size?: string;
  descriptions?: string;
  item_number?: string;
  keyword: string;
  city: string;
  source: string;
  supplier_name: string;
  supplier_url: string;
  supplier_city: string;
  supplier_rating?: string;
  supplier_desc?: string;
};

type GetTradingProductsResponse = {
  tradingProducts: TradingProduct[];
  total: number;
};

export function getTradingProducts(data: GetTradingProductsRequest) {
  return request<GetTradingProductsResponse>(
    '/api/trading/getTradingProducts',
    data,
    {}
  );
}

export type TradingProductsPayload = {
  suppliers: (string | undefined)[][];
  tradingProducts: (string | undefined)[][];
};

type createTradingProductResponse = {
  suppliers_upserted_count: number;
  products_upserted_count: number;
};

export function createTradingProduct(data: TradingProductsPayload) {
  return request<createTradingProductResponse>(
    '/api/trading/createTradingProduct',
    data,
    {}
  );
}

export type UpdateTradingProductPayload = {
  uuid: string;
  data: {
    item_number: string;
    keyword: string;
    product_name: string;
    product_size: string;
    descriptions: string;
  };
};
export function updateTradingProduct(data: UpdateTradingProductPayload) {
  return request<createTradingProductResponse>(
    '/api/trading/updateTradingProduct',
    data,
    {}
  );
}

type DeleteTradingProductRequest = {
  product_id: string;
};

export function deleteTradingProduct(data: DeleteTradingProductRequest) {
  return request<createTradingProductResponse>(
    '/api/trading/deleteTradingProduct',
    data,
    {}
  );
}

export type GetTradingProductsMetaRequest = {
  keyword: string;
};

export type GetTradingProductsMetaResponse = {
  meta: {
    city: string;
    source: string;
    count: number;
  }[];
};

export function getTradingProductsMeta(data: GetTradingProductsMetaRequest) {
  return request<GetTradingProductsMetaResponse>(
    '/api/trading/getTradingProductsMeta',
    data,
    {}
  );
}

type Catalog = {
  uuid: string;
  client: string;
  created_at: string;
};

export type GetCatalogsResponse = {
  catalogs: Catalog[];
};

export function getCatalogs() {
  return request<GetCatalogsResponse>('/api/trading/getCatalogs');
}

type CreateCatalogRequest = {
  uuid: string;
  client: string;
  title: string;
  keyword: string;
  email: string;
  companyName: string;
  location: string;
  products: string[][];
};

type CreateCatalogResponse = {
  catalog_id: string;
  products_count: number;
};

export function createCatalog(data: CreateCatalogRequest) {
  return request<CreateCatalogResponse>('/api/trading/createCatalog', data, {});
}

type GetCatalogByIdRequest = {
  uuid: string;
};

export type TradingProductForCatalog = {
  uuid: string;
  img_url: string;
  product_json: string | null;
  product_name: string | null;
};

export type CatalogData = {
  client: string;
  title: string;
  keyword: string;
  email: string;
  companyName: string;
  location: string;
  selected_products: TradingProductForCatalog[];
};

type GetCatalogByIdResponse = {
  catalog: CatalogData;
};

export function getCatalogById(data: GetCatalogByIdRequest) {
  return request<GetCatalogByIdResponse>(
    '/api/trading/getCatalogById',
    data,
    {}
  );
}

export type CreateEmailRequest = {
  uuid: string;
  customer_name: string;
  customer_email: string;
  email_subject: string;
  email_contents: string;
};

type CreateEmailResponse = {
  email_id: string;
};

export function createEmail(data: CreateEmailRequest) {
  return request<CreateEmailResponse>('/api/trading/createEmail', data, {});
}

type GetEmailByIdRequest = {
  uuid: string;
};

type GetEmailByIdResponse = {
  email: {
    uuid: string;
    customer_name: string;
    customer_email: string;
    email_subject: string;
    email_contents: string;
  };
};

export function getEmailById(data: GetEmailByIdRequest) {
  return request<GetEmailByIdResponse>('/api/trading/getEmailById', data, {});
}

export type GetEmailsResponse = {
  emails: {
    uuid: string;
    customer_name: string;
    customer_email: string;
    email_subject: string;
  }[];
};

export function getEmails() {
  return request<GetEmailsResponse>('/api/trading/getEmails');
}
